<template>
  <div id="page">
    <v-header/>

    <v-loading-spinner v-if="$apollo.loading" />

    <div class="main">
      <router-view v-if="!$apollo.loading"></router-view>
    </div>

    <v-tracking-notice v-if="showCookieNotice" />

    <v-footer />

    <v-icons/>
  </div>
</template>

<script>
import query from '@/services/api/query';

export default {
  name: 'Main',
  data() {
    return {
      cookieSettings: true,
      setting: {},
    };
  },
  computed: {
    showCookieNotice() {
      let local = localStorage.getItem('PROFUNDA.COOKIE_NOTICE');
      return !local && this.cookieSettings
    },
  },
  methods: {
    addEventListener() {
      this.$eventBus.$on(this.$events('GLOBAL.HIDE_TRACKING_NOTICE'), () => {
        this.cookieSettings = false
      });

      this.$eventBus.$on(this.$events('GLOBAL.SHOW_TRACKING_NOTICE'), () => {
        localStorage.removeItem('PROFUNDA.COOKIE_NOTICE');
        window.location.reload()
      });
    }
  },
  created() {
    this.addEventListener();
  },
  apollo: {
    setting: {
      query: query.settings,
    }
  },
  components: {
    vHeader: () => import('@/components/header'),
    vIcons: () => import('@/components/icons'),
    vFooter: () => import('@/components/footer'),
    vLoadingSpinner: () => import('@/components/loading-spinner'),
    vTrackingNotice: () => import('@/components/tracking-notice'),
  },
};
</script>
